module.exports = __webpack_public_path__ + "static/media/tech-writing.82fed3f1.png";